module.exports = __webpack_public_path__ + "img/feature_3.0291e390.svg";